import React from 'react';
import PropTypes from 'prop-types';
import Partials from '../partials';

const propTypes = {
    title: PropTypes.string,
    blocks: PropTypes.array,
};

const defaultProps = {
    title: 'Books',
    blocks: [],
};

const TextLayout = ({ title, blocks }) => (
    <div className="layout layout-text">
        <h1 className="title page-title">{title}</h1>
        <Partials.Block blocks={blocks || []} />
    </div>
);

TextLayout.propTypes = propTypes;
TextLayout.defaultProps = defaultProps;

export default TextLayout;



// WEBPACK FOOTER //
// ./components/layouts/TextLayout.jsx